import { render } from "./PatientAdmissionsDischargesChart.vue?vue&type=template&id=711f1a36&ts=true"
import script from "./PatientAdmissionsDischargesChart.vue?vue&type=script&lang=ts"
export * from "./PatientAdmissionsDischargesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__